export interface INonDeliveryDays {
  customerId: number;
  courierCcNonDeliveryDays: string[];
  courierNonDeliveryDays: string[];
  upsCcNonDeliveryDays: string[];
  upsNonDeliveryDays: string[];
}

export enum ResourceName {
  NON_DELIVERY_DAYS = 'non_delivery_days',
}

export enum ResourceAction {
  CREATE = 'create',
  UPDATE = 'update',
}

export interface INonDeliveryDaysProps {
  loading: boolean;
  selectedCustomerId: number;
  classes: Record<string, string>;
  submitRequestNonDeliveryDays: () => void;
  setSelectedCustomerId: (customerId: number) => void;
  nonDeliveryDays: INonDeliveryDays | null;
  handleCheckboxChange?: (field: keyof INonDeliveryDays, day: string, checked: boolean) => void;
  hasAddUpdateNonDeliveryDaysPermission: boolean;
  isChanged: boolean;
}

export interface IRole {
  resource_name: ResourceName;
  resource_action: ResourceAction;
}

export interface IPermissions {
  application_manager_users_manage_customer_level?: {
    customers?: string[];
  };
}

export interface WeekdayCheckboxRowProps {
  title: string;
  nonDeliveryDays?: string[];
  onChange?: (index: number, checked: boolean) => void;
  disabled?: boolean;
}

export enum SnackbarSeverity {
  SUCCESS = 'success',
  ERROR = 'error',
}

export type SnackbarState = {
  open: boolean;
  message: string;
  severity: SnackbarSeverity;
};

export enum SnackbarMessages {
  SAVE_SUCCESS = 'Saved non delivery days!',
  SAVE_ERROR = 'Error saving data.',
}
